'use client';

import React from 'react';
import { styled } from '@mui/material/styles';

export type RootSvgProps<P = unknown> = Omit<
  React.SVGProps<SVGSVGElement>,
  'ref'
> & {
  ref?: React.Ref<SVGSVGElement>;
} & P;

const Svg = styled('svg')({
  verticalAlign: 'bottom',
});

export default Svg;
